const globalData = {
	sessionKey:null,
	userInfo:null,
	account:null,
	token: null
  }
  export default globalData


// WEBPACK FOOTER //
// ./src/service/globalData.js